import React from 'react'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'
import ReportSubtitleV1 from 'components/Text/ReportSubtitleV1'
import ReportSubtitle from 'components/Text/ReportSubtitle'
import useLanguage from 'features/languageReport/useLanguage'
import {Lobe} from 'api/analysisApi'
import {Section5Desc} from './Style'

export default function EEGSummaryBrainAgeDevelopmentAPI(props: {
  brainAgeGraphImage: string | undefined
  avg: number
  age: number
  lobe: Lobe
  isSummary?: boolean
}) {
  const {brainAgeGraphImage, avg, lobe, age, isSummary} = props
  const {textEegAPI} = useLanguage('eeg')
  const classes = useStyles()

  return (
    <div className={classes.eeg}>
      {isSummary ? (
        <ReportSubtitleV1 number='5'>
          {textEegAPI?.infant_youth.section.brain_age.title}
        </ReportSubtitleV1>
      ) : (
        <ReportSubtitle number='5'>
          {textEegAPI?.infant_youth.section.brain_age.title}
        </ReportSubtitle>
      )}

      <div className={classes.childValueGraphFull}>
        <div className='Child-Graph-Desc'>
          <Section5Desc className='Top-Desc'>
            {textEegAPI?.infant_youth.section.brain_age.description[0]}
            <br />
            {textEegAPI?.infant_youth.section.brain_age.description[1]}
          </Section5Desc>
        </div>
        <div className='Child-Graph-Box'>
          <div className='Child-Graph'>
            {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
            <div
              style={{
                backgroundImage: `url(${brainAgeGraphImage})`,
                backgroundRepeat: 'no-repeat',
                width: '100%',
                height: 500,
                backgroundSize: 'contain',
              }}
            >
              <div className='Score-Layout'>
                <div className='Bottom-Avg'>
                  <div className={`Avg-Label ${avg > age ? '' : 'Red-Label'}`}>
                    {
                      textEegAPI?.infant_youth.section.brain_age.brain_age_image
                        .brain_age
                    }
                  </div>
                  <div className='Avg-Score'>
                    <span
                      className={`Avg-Score-Value ${
                        avg > age ? '' : 'Red-Label'
                      }`}
                      style={{lineHeight: '77px'}}
                    >
                      {avg}
                    </span>
                    <span
                      className={`Avg-Score-Unit ${
                        avg > age ? '' : 'Red-Label'
                      }`}
                    >
                      {
                        textEegAPI?.infant_youth.section.brain_age
                          .brain_age_image.age_unit
                      }
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    width: '100%',
                    height: '1px',
                    backgroundColor: '#e0e0e0',
                  }}
                />
                <div className='Bottom-Score' style={{marginTop: '13px'}}>
                  <div className='Current-Label'>
                    {
                      textEegAPI?.infant_youth.section.brain_age.brain_age_image
                        .actual_age
                    }{' '}
                    {age}{' '}
                    {
                      textEegAPI?.infant_youth.section.brain_age.brain_age_image
                        .age_unit
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className='Child-info-alert' style={{marginBottom: 45}}>
              {
                textEegAPI?.infant_youth.section.brain_age.brain_age_image
                  .annotation
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
